import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Cell } from 'recharts';
import { cur } from '@/lib/currency';

const COLORS = [
  'hsl(var(--primary))',
  'hsl(var(--secondary))',
  '#f59e0b',
  '#8b5cf6',
  '#ec4899',
];

const CustomTooltip = ({ active, payload }) => {
  if (active && payload?.length) {
    return (
      <div className="bg-card border border-border rounded-xl px-3 py-2 shadow-lg text-xs">
        <p className="font-bold text-foreground mb-1">{payload[0]?.payload?.name}</p>
        <p className="text-primary">{(payload[0].value || 0).toLocaleString('ar-EG', { maximumFractionDigits: 0 })} {cur()}</p>
      </div>
    );
  }
  return null;
};

export default function TopCustomersChart({ data = [] }) {
  const trimmed = data.map(d => ({ ...d, shortName: d.name?.length > 14 ? d.name.substring(0, 14) + '…' : d.name }));

  return (
    <div className="bg-card border border-border rounded-2xl p-5 shadow-sm">
      <h3 className="font-bold text-foreground mb-4 text-sm">أفضل العملاء — هذا الشهر</h3>
      {trimmed.length === 0 ? (
        <p className="text-muted-foreground text-xs text-center py-8">لا توجد بيانات</p>
      ) : (
        <div className="h-44">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={trimmed} layout="vertical" margin={{ top: 0, right: 20, left: 10, bottom: 0 }}>
              <XAxis type="number" tick={{ fontSize: 10, fill: 'hsl(var(--muted-foreground))' }} axisLine={false} tickLine={false}
                tickFormatter={v => v >= 1000 ? `${(v / 1000).toFixed(0)}k` : v} />
              <YAxis type="category" dataKey="shortName" tick={{ fontSize: 10, fill: 'hsl(var(--muted-foreground))' }} axisLine={false} tickLine={false} width={80} />
              <Tooltip content={<CustomTooltip />} />
              <Bar dataKey="total" radius={[0, 6, 6, 0]}>
                {trimmed.map((_, i) => <Cell key={i} fill={COLORS[i % COLORS.length]} />)}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </div>
      )}
    </div>
  );
}